import { observer } from 'mobx-react';
import { Button } from '../../components/button';
import style from './style.module.scss';
import { useOktaAuth } from '@okta/okta-react';

export const LoginPage = observer(() => {
    const { oktaAuth } = useOktaAuth();

    const signIn = () => {
        oktaAuth.signInWithRedirect({ originalUri: '/' });
    };

    return (
        <div className={style.container}>
            <img loading="lazy" src="/ct-logo-large.png" alt="logo" />

            <Button
                variant="primary"
                onClick={signIn}
                className={style.submit_button}
            >
                Sign In With Okta
            </Button>
        </div>
    );
});
